import { defineMessages } from 'react-intl';

const ID_PREFIX = 'JoinSiteUserDropdown.';
export const messages = defineMessages({
  logIn: {
    id: `${ID_PREFIX}logIn`,
    defaultMessage: 'Log in'
  },
  joinTeam: {
    id: `${ID_PREFIX}joinTeam`,
    defaultMessage: 'Find my team'
  },
  profile: {
    id: `${ID_PREFIX}profile`,
    defaultMessage: 'Profile'
  },
  licenses: {
    id: `${ID_PREFIX}licenses`,
    defaultMessage: 'Licenses'
  },
  logOut: {
    id: `${ID_PREFIX}logOut`,
    defaultMessage: 'Log out'
  },
  logOutTriggerText: {
    id: `${ID_PREFIX}logOutTriggerText`,
    defaultMessage: 'Sign in'
  },
  switchAccount: {
    id: `${ID_PREFIX}switchAccount`,
    defaultMessage: 'Switch Account'
  }
});
